<template>
  <div>
    <el-form
      class="firStepForm"
      :model="formregisterpay"
      :rules="formRulesPay"
      ref="formRef"
    >
      <ul>
        <li class="liFull">
          <!-- 购买人身份 -->
          <el-form-item prop="entity_type" :label="$fanyi('购买人身份')">
            <el-radio-group
              v-model="formregisterpay.entity_type"
              class="entityTypeGroup"
              :disabled="readonly"
              @change="handleEntityTypeChange"
            >
              <!-- 公司进口商 -->
              <el-radio :label="1">{{ $fanyi("公司进口商") }}</el-radio>
              <!-- 个人 -->
              <el-radio :label="2">{{ $fanyi("个人") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="contacts" :label="$fanyi('全名')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.contacts,
              }"
              @focus="validateField('contacts')"
              @blur="validateField('contacts')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.contacts"
            />
            <div class="gou" v-if="formInputTrue.contacts">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="zip_code" :label="$fanyi('邮编')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.zip_code,
              }"
              @focus="validateField('zip_code')"
              @blur="validateField('zip_code')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.zip_code"
            />
            <div class="gou" v-if="formInputTrue.zip_code">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="city" :label="$fanyi('城市')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.city,
              }"
              @focus="validateField('city')"
              @blur="validateField('city')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.city"
            />
            <div class="gou" v-if="formInputTrue.city">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="province" :label="$fanyi('省份')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.province,
              }"
              @focus="validateField('province')"
              @blur="validateField('province')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.province"
            />
            <div class="gou" v-if="formInputTrue.province">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="country" :label="$fanyi('国家')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.country,
              }"
              @focus="validateField('country')"
              @blur="validateField('country')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.country"
            />
            <div class="gou" v-if="formInputTrue.country">✔</div>
          </el-form-item>
        </li>
        <li class="liFull">
          <el-form-item prop="address" :label="$fanyi('地址')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.address,
              }"
              @focus="validateField('address')"
              @blur="validateField('address')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.address"
            />
            <div class="gou" v-if="formInputTrue.address">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="mobile" :label="$fanyi('电话')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.mobile,
              }"
              @focus="validateField('mobile')"
              @blur="validateField('mobile')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.mobile"
            />
            <div class="gou" v-if="formInputTrue.mobile">✔</div>
          </el-form-item>
        </li>
        <li>
          <el-form-item prop="email" :label="$fanyi('邮件箱')">
            <input
              class="ipt"
              v-bind:class="{
                istrueInput: formInputTrue.email,
              }"
              @focus="validateField('email')"
              @blur="validateField('email')"
              autocomplete="new-password"
              :readonly="readonly"
              v-model="formregisterpay.email"
            />
            <div class="gou" v-if="formInputTrue.email">✔</div>
          </el-form-item>
        </li>
        <template v-if="isCompany">
          <li>
            <!-- C.F -->
            <el-form-item prop="cnpj" :label="$fanyi('C.F')">
              <input
                class="ipt"
                v-bind:class="{
                  istrueInput: formInputTrue.cnpj,
                }"
                @focus="validateField('cnpj')"
                @blur="validateField('cnpj')"
                autocomplete="new-password"
                :readonly="readonly"
                v-model="formregisterpay.cnpj"
              />
              <div class="gou" v-if="formInputTrue.cnpj">✔</div>
            </el-form-item>
          </li>
          <li>
            <!-- P.IVA/VAT NO -->
            <el-form-item prop="vat_number" :label="$fanyi('P.IVA/VAT NO')">
              <input
                class="ipt"
                v-bind:class="{
                  istrueInput: formInputTrue.vat_number,
                }"
                @focus="validateField('vat_number')"
                @blur="validateField('vat_number')"
                autocomplete="new-password"
                :readonly="readonly"
                v-model="formregisterpay.vat_number"
              />
              <div class="gou" v-if="formInputTrue.vat_number">✔</div>
            </el-form-item>
          </li>
          <li>
            <!-- SDI -->
            <el-form-item prop="sdi" :label="$fanyi('SDI')">
              <input
                class="ipt"
                v-bind:class="{
                  istrueInput: formInputTrue.sdi,
                }"
                @focus="validateField('sdi')"
                @blur="validateField('sdi')"
                autocomplete="new-password"
                :readonly="readonly"
                v-model="formregisterpay.sdi"
              />
              <div class="gou" v-if="formInputTrue.sdi">✔</div>
            </el-form-item>
          </li>
        </template>
      </ul>
    </el-form>
  </div>
</template>
<script>
// 公司进口商 entity_type
const ENTITY_TYPE_COMPANY = 1;
// 个体户进口商 entity_type
const ENTITY_TYPE_INDIVIDUAL = 2;
// 仅公司视图使用的非共用字段
const COMPANY_ONLY_FIELDS = ["vat_number", "cnpj", "sdi"];

export default {
  props: {
    // 配送单支付等场景：表单只读不可编辑
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formInputTrue: {}, // 输入框校验通过样式
    };
  },
  computed: {
    formregisterpay() {
      return (
        this.$parent.jinkoushang || this.$parent.$parent.$parent.jinkoushang
      );
    },
    // 是否为公司进口商，控制税号类字段显示与校验
    isCompany() {
      return Number(this.formregisterpay.entity_type) === ENTITY_TYPE_COMPANY;
    },
    // 按购买人身份动态生成校验规则
    formRulesPay() {
      const requiredRule = {
        required: true,
        message: this.$fanyi("不能为空"),
        trigger: "blur",
      };
      const rules = {
        entity_type: [requiredRule],
        zip_code: [requiredRule],
        address: [requiredRule],
        contacts: [requiredRule],
        city: [requiredRule],
        province: [requiredRule],
        mobile: [requiredRule],
        email: [
          requiredRule,
          {
            type: "email",
            message: this.$fanyi("请输入正确的邮箱地址"),
            trigger: ["blur", "change"],
          },
        ],
        country: [requiredRule],
      };
      if (this.isCompany) {
        rules.cnpj = [requiredRule];
        rules.vat_number = [requiredRule];
        rules.sdi = [requiredRule];
      }
      return rules;
    },
  },
  mounted() {
    this.ensureEntityTypeDefault();
    if (this.$parent.$parent.$parent.jiancha) {
      this.checkAllInput();
    }
  },
  methods: {
    // 缺省购买人身份为公司进口商
    ensureEntityTypeDefault() {
      if (!this.formregisterpay.entity_type) {
        this.$set(this.formregisterpay, "entity_type", ENTITY_TYPE_COMPANY);
      } else {
        this.formregisterpay.entity_type = Number(this.formregisterpay.entity_type);
      }
    },
    // 切换购买人身份：个体户清空税号类字段；任意切换时清除校验
    handleEntityTypeChange(entityType) {
      if (Number(entityType) === ENTITY_TYPE_INDIVIDUAL) {
        COMPANY_ONLY_FIELDS.forEach((field) => {
          this.formregisterpay[field] = "";
          this.formInputTrue[field] = false;
        });
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    // 个体户提交前清空税号类字段，供支付页 addressStore 前调用
    prepareSubmitData() {
      if (!this.isCompany) {
        COMPANY_ONLY_FIELDS.forEach((field) => {
          this.formregisterpay[field] = "";
        });
      }
    },
    // 检查所有选项
    checkAllInput() {
      let checkOpt = [
        "entity_type",
        "address",
        "city",
        "contacts",
        "country",
        "province",
        "email",
        "mobile",
        "zip_code",
      ];
      if (this.isCompany) {
        checkOpt = checkOpt.concat(COMPANY_ONLY_FIELDS);
      }
      for (let i in checkOpt) {
        this.validateField(checkOpt[i]);
      }
    },
    // 手动触发表单验证
    validateField(type) {
      if (this.formregisterpay[type])
        this.formregisterpay[type] = this.formregisterpay[type].trim();
      this.$refs.formRef.validateField(type, (v) => {
        if (v == "") {
          this.formInputTrue[type] = true;
        } else {
          this.formInputTrue[type] = false;
        }
        this.$forceUpdate();
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../../css/mixin.scss";
.firStepForm {
  width: 740px;
  /deep/.el-form-item {
    margin-bottom: 30px;
  }
  /deep/.el-form-item__error {
    top: 50px;
  }
  .entityTypeGroup {
    /deep/ .el-radio {
      margin-right: 24px;
      .el-radio__label {
        font-size: 14px;
        color: #000000;
      }
    }
  }
  > ul {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    > li {
      width: 360px;
      display: flex;
      flex-direction: column;
      &.liFull {
        width: 100%;
        input {
          width: 100%;
        }
      }
      // 表单标题样式
      /deep/.el-form-item__label {
        padding: 0;
        text-align: left;
        float: none;
        display: block;
        width: 100%;
        line-height: 14px;
        height: 14px;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        &::before {
          display: none;
        }
      }
      /deep/.elistrueInput .el-input__inner {
        background: #f3f6fc;
        border: 1px solid #abbbd2;
        border-radius: 5px;
        position: relative;
      }

      input {
        width: 360px;
        height: 48px;
        background: #ffffff;
        border: 1px solid #dedede;
        font-size: 14px;
        font-weight: 400;
        border-radius: 5px;
        padding: 0 10px;
        transition: 0.4s;
        &::placeholder {
          color: #b6b6b6;
        }
        &:focus {
          border: 1px solid $homePageSubjectColor;
          box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
        }
        &.istrueInput {
          background: #f3f6fc;
          border: 1px solid #abbbd2;
          border-radius: 5px;
          position: relative;
        }
      }

      .gou {
        position: absolute;
        font-weight: bold;
        right: 13px;
        top: 3px;
        color: #009246;
        &.regCodegou {
          right: 222px;
        }
      }
      .xuanZeGuoJia {
        width: 100%;
        height: 48px;
        background: #f3f6fc;
        border-radius: 5px;

        /deep/.el-input__inner {
          width: 100%;
          height: 48px;
          background: #f3f6fc;
          border: 1px solid #abbbd2;
          border-radius: 5px;
        }
        /deep/.el-icon-arrow-up {
          color: $homePageSubjectColor;
          font-weight: bold;
          font-size: 15px;
        }
      }
      .formZiDingYi {
        //多个输入框自定义样式
        display: flex;
        align-items: center;
        margin-top: -14px;
        .youbian {
          margin-right: 20px;
          input {
            width: 130px;
          }
          .gou {
            right: 33px;
          }
        }
        .chengshi {
          input {
            width: 210px;
          }
        }
      }
    }
    .guoJiaQuHao {
      .shouJIHaoCon {
        display: flex;
        align-items: center;
        .quHao {
          width: 58px;
          height: 48px;
          background: #ffffff;
          border: 1px solid #dedede;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          &.istrueInput {
            background: #f3f6fc;
            border: 1px solid #abbbd2;
            border-radius: 5px;
            position: relative;
          }
        }
        input {
          width: 312px;
        }
      }
    }
    .yanzhengma {
      .yanzhengmaBox {
        display: flex;
        align-items: center;
        input {
          width: 167px;
          height: 48px;
          background: #ffffff;
          border: 1px solid #dedede;
          border-radius: 5px;
          &.istrueInput {
            background: #f3f6fc;
            border: 1px solid #abbbd2;
            border-radius: 5px;
            position: relative;
          }
        }
        button {
          margin-left: 80px;
          width: 195px;
          height: 48px;
          background: $homePageSubjectColor;
          border: 1px solid $homePageSubjectColor;
          border-radius: 5px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .xieYi {
      width: 360px;
      display: flex;
      align-items: center;
      .fuWuXieYi {
        display: flex;
        align-items: center;
        a {
          width: 165px;
          height: 35px;
          font-size: 14px;

          font-weight: 300;
          color: #2f2f2f;
          line-height: 35px;
          margin: 0 5px 0 10px;
        }
        button {
          width: 182px;
          height: 48px;
          background: #009246;
          border: 1px solid #009246;
          border-radius: 5px;
          color: white;
        }
      }
    }
    .xiaYiBuHuoFanHui {
      .caoZuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        button {
          width: 45%;
          height: 48px;
          background: #009246;
          border: 1px solid #009246;
          border-radius: 5px;
          color: white;
        }
        .shangYiBu {
          background: $homePageSubjectColor;
        }
        .xiaYiBu {
          background: #009246;
        }
      }
    }
  }
  .showregisterInfo {
    width: 360px;
    height: 48px;
    font-size: 13px;
    line-height: 48px;
    border: 1px solid #dedede;
    background-color: #f3f3f3;
    border-radius: 5px;
    padding: 0 10px;
    transition: 0.4s;
  }
}
.ipt {
  padding-right: 30px !important;
}
</style>
